import { DialogComponent } from '@theme/dialog';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that manages a klaviyo bis drawer.
 *
 * @extends {DialogComponent}
 */
class KlaviyoDialogComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    this.variantId = this.dataset.variantId
    document.addEventListener(ThemeEvents.variantUpdate, this.onVariantChange.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.onVariantChange.bind(this))
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  onVariantChange(event) {
    this.variantId = event.detail.resource ? event.detail.resource.id : null;
    const title = event.detail.resource ? event.detail.resource.title : null;

    if (this.refs.variantTitle) this.refs.variantTitle.innerHTML = title
  }

  async onSubmit() {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
                type: 'profile',
                attributes: {
                    email: this.refs.emailInput.value,
                }
            }
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${this.variantId}`
            }
          }
        }
      }
    }

    const result = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.klaviyoKey}`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload),
    })

    if (result.status === 202) {
      this.refs.signupForm.classList.add('hidden')
      this.refs.statusContainer.classList.remove('hidden')
      this.refs.errorMessage.classList.add('hidden')
    } else {
      this.refs.errorMessage.classList.remove('hidden')

      const errors = await result.json()
      const messages = errors.errors.map(error => error.detail)

      this.refs.errorMessage.innerHTML = messages.join('\n')
    }
  }
}

if (!customElements.get('klaviyo-dialog-component')) {
  customElements.define('klaviyo-dialog-component', KlaviyoDialogComponent);
}
